import { type LDLogger } from 'launchdarkly-react-client-sdk'
import { isLaunchDarklyNetworkError } from './isLaunchDarklyNetworkError'

const LD_LOG_PREFIX = '[LaunchDarkly] '

/**
 * LaunchDarkly logger that drops transient flag-fetch network errors from the `error`
 * channel. Those otherwise reach `console.error` on every backgrounded or dropped flag
 * request and are captured by Datadog RUM as noise; every other error message (invalid
 * context, bad environment id) still surfaces to `console.error` and RUM.
 *
 * `warn`/`error` go to `console` (the only methods the repo's `no-console` rule allows);
 * `info`/`debug` are dropped — that output is dev-console-only, never reaches RUM, and the
 * SSR client already runs LaunchDarkly at `warn` level.
 *
 * Built directly on `console` rather than the exported `basicLogger`, which routes every
 * level to `console.log` — that would move real LaunchDarkly errors off `console.error`
 * and out of RUM entirely.
 */
export const createFilteredLDLogger = (): LDLogger => ({
  debug: () => undefined,
  info: () => undefined,
  warn: (message) => console.warn(LD_LOG_PREFIX + message),
  error: (message) => {
    if (isLaunchDarklyNetworkError({ message })) {
      return
    }

    console.error(LD_LOG_PREFIX + message)
  },
})
